module.exports = __webpack_public_path__ + "static/media/k-matik.5813b78d.svg";